function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * Functions that modify ViewingControls menu.
 *
 * ViewingControls menu is the 3-dot menu that every item in the workbench gets.
 */

import { remove } from "lodash-es";
import { runInAction } from "mobx";
import createGuid from "terriajs-cesium/Source/Core/createGuid";
/**
 * Adds a new viewing control menu option.
 *
 * `addMenuItem` adds a `generateViewingControl` function that gets called for each workbench item. This function can at runtime decide if it wants to show an option for the item and return the `ViewingControl` definition or `undefined` if it does not want to show an option.
 *
 * @param viewState - The {@link ViewState} instance.
 * @param generateViewingControl - A function that either generates a {@link ViewingControl} description for the given catalog item or returns `undefined` if no option should be shown
 * @returns A cleanup function that when called will remove the option
 */
export function addMenuItem(viewState, generateViewingControl) {
  runInAction(() => {
    viewState.globalViewingControlOptions.push(item => {
      var _viewingControl$id;
      const viewingControl = generateViewingControl(item);
      return viewingControl === undefined ? undefined : _objectSpread({
        // if id is not specified, create one
        id: (_viewingControl$id = viewingControl.id) !== null && _viewingControl$id !== void 0 ? _viewingControl$id : createGuid()
      }, viewingControl);
    });
  });
  return () => {
    runInAction(() => {
      remove(viewState.globalViewingControlOptions, fn => fn === generateViewingControl);
    });
  };
}